import { Button, IconPlus } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Event } from 'typings'
import { useAnalytics } from 'use-analytics'
import { useDrawerState } from '../../../../../Drawer'
import styles from '../coupons.css'
import { messages } from '../messages'
import { Editor } from './Editor'

export type UtmsType = {
  utmSource: string[]
  utmCampaign: string[]
}

export function CreateCoupon(props: UtmsType) {
  const { utmSource, utmCampaign } = props
  const { track } = useAnalytics()
  const hasUTMs = Boolean(utmSource.length || utmCampaign.length)

  const { $t } = useIntl()

  const drawerState = useDrawerState()

  const handleCreateClick = () => {
    track(Event.CREATE_COUPON_BY_UTM_CLICK)
    drawerState.show()
  }

  return (
    <>
      <Button
        variant="neutralTertiary"
        icon={<IconPlus />}
        disabled={!hasUTMs}
        onClick={handleCreateClick}
        className={styles.cursorOnDisabled}
      >
        {$t(messages.create)}
      </Button>

      <Editor drawerState={drawerState} utms={props} />
    </>
  )
}
